import { cn } from "@lib/cn";
import { SESSIONS_TABLE_SIZES } from "@pages/analytics/constants";

const BASE_CLASSNAME =
  "tw-px-2 tw-text-xs tw-font-sans tw-h-10 tw-text-blue-500 tw-font-medium tw-flex tw-items-center";

export const SessionsTableHeader = () => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-blue-100">
      <div
        className={cn(
          BASE_CLASSNAME,
          "tw-flex-auto tw-pl-4 tw-pr-2 tw-min-w-0 tw-w-80 tw-shrink-0 tw-mr-auto -2xl:tw-w-52 -md:tw-w-60",
        )}
      >
        Reader
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: SESSIONS_TABLE_SIZES.SESSION_STARTED }}
      >
        Session started
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: SESSIONS_TABLE_SIZES.READING_TIME }}
      >
        Reading time
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: SESSIONS_TABLE_SIZES.CLICKED_CTA }}
      >
        Clicked link
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: SESSIONS_TABLE_SIZES.PROGRESS }}
      >
        Progress
      </div>
      <div
        className={BASE_CLASSNAME}
        style={{ width: SESSIONS_TABLE_SIZES.LOCATION }}
      >
        Location
      </div>
      <div
        className={cn(BASE_CLASSNAME, "tw-pr-4")}
        style={{ width: SESSIONS_TABLE_SIZES.DEVICE }}
      >
        Device
      </div>
    </div>
  );
};
